/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationListResponse,
  ConfigurationResponse,
  CreateConfigurationRequest,
  UpdateConfigurationRequest,
} from '../models/index';
import {
    ConfigurationListResponseFromJSON,
    ConfigurationListResponseToJSON,
    ConfigurationResponseFromJSON,
    ConfigurationResponseToJSON,
    CreateConfigurationRequestFromJSON,
    CreateConfigurationRequestToJSON,
    UpdateConfigurationRequestFromJSON,
    UpdateConfigurationRequestToJSON,
} from '../models/index';

export interface CreateCatalogTemplateRequest {
    createConfigurationRequest: CreateConfigurationRequest;
    sessionId?: string;
}

export interface DeleteCatalogTemplateRequest {
    id: string;
    sessionId?: string;
}

export interface GetCatalogTemplateRequest {
    id: string;
    sessionId?: string;
}

export interface ListCatalogTemplatesRequest {
    scope?: string;
    sessionId?: string;
}

export interface UpdateCatalogTemplateRequest {
    id: string;
    updateConfigurationRequest: UpdateConfigurationRequest;
    sessionId?: string;
}

/**
 * CatalogTemplatesApi - interface
 * 
 * @export
 * @interface CatalogTemplatesApiInterface
 */
export interface CatalogTemplatesApiInterface {
    /**
     * Creates a new catalog template. Use scope SYSTEM and tenantId = admin tenant for global (Cobalt) templates; use scope TENANT and tenantId = target tenant for customer-specific templates. configurationData must be a valid OSCAL document with top-level \'catalog\' key.
     * @summary Create catalog template
     * @param {CreateConfigurationRequest} createConfigurationRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogTemplatesApiInterface
     */
    createCatalogTemplateRaw(requestParameters: CreateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Creates a new catalog template. Use scope SYSTEM and tenantId = admin tenant for global (Cobalt) templates; use scope TENANT and tenantId = target tenant for customer-specific templates. configurationData must be a valid OSCAL document with top-level \'catalog\' key.
     * Create catalog template
     */
    createCatalogTemplate(requestParameters: CreateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * Deactivates/removes a catalog template. Access is restricted by configuration RLS.
     * @summary Remove catalog template
     * @param {string} id 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogTemplatesApiInterface
     */
    deleteCatalogTemplateRaw(requestParameters: DeleteCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Deactivates/removes a catalog template. Access is restricted by configuration RLS.
     * Remove catalog template
     */
    deleteCatalogTemplate(requestParameters: DeleteCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * Returns a single catalog template. Access is restricted by configuration RLS (tenant and scope).
     * @summary Get catalog template by ID
     * @param {string} id Configuration ID (UUID) of the catalog template
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogTemplatesApiInterface
     */
    getCatalogTemplateRaw(requestParameters: GetCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Returns a single catalog template. Access is restricted by configuration RLS (tenant and scope).
     * Get catalog template by ID
     */
    getCatalogTemplate(requestParameters: GetCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

    /**
     * Returns catalog templates visible to the current session. Includes system (global/Cobalt) templates and tenant-specific templates for the user\'s effective tenants. Optional scope filter: SYSTEM (global only) or TENANT (customer-specific only).
     * @summary List catalog templates
     * @param {string} [scope] Optional scope filter: SYSTEM (global) or TENANT
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogTemplatesApiInterface
     */
    listCatalogTemplatesRaw(requestParameters: ListCatalogTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>>;

    /**
     * Returns catalog templates visible to the current session. Includes system (global/Cobalt) templates and tenant-specific templates for the user\'s effective tenants. Optional scope filter: SYSTEM (global only) or TENANT (customer-specific only).
     * List catalog templates
     */
    listCatalogTemplates(requestParameters: ListCatalogTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse>;

    /**
     * Updates an existing catalog template. Only name, description, and configurationData can be updated; scope and tenant are fixed.
     * @summary Update catalog template
     * @param {string} id 
     * @param {UpdateConfigurationRequest} updateConfigurationRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogTemplatesApiInterface
     */
    updateCatalogTemplateRaw(requestParameters: UpdateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>>;

    /**
     * Updates an existing catalog template. Only name, description, and configurationData can be updated; scope and tenant are fixed.
     * Update catalog template
     */
    updateCatalogTemplate(requestParameters: UpdateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse>;

}

/**
 * 
 */
export class CatalogTemplatesApi extends runtime.BaseAPI implements CatalogTemplatesApiInterface {

    /**
     * Creates a new catalog template. Use scope SYSTEM and tenantId = admin tenant for global (Cobalt) templates; use scope TENANT and tenantId = target tenant for customer-specific templates. configurationData must be a valid OSCAL document with top-level \'catalog\' key.
     * Create catalog template
     */
    async createCatalogTemplateRaw(requestParameters: CreateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['createConfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'createConfigurationRequest',
                'Required parameter "createConfigurationRequest" was null or undefined when calling createCatalogTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/catalog-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConfigurationRequestToJSON(requestParameters['createConfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new catalog template. Use scope SYSTEM and tenantId = admin tenant for global (Cobalt) templates; use scope TENANT and tenantId = target tenant for customer-specific templates. configurationData must be a valid OSCAL document with top-level \'catalog\' key.
     * Create catalog template
     */
    async createCatalogTemplate(requestParameters: CreateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.createCatalogTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivates/removes a catalog template. Access is restricted by configuration RLS.
     * Remove catalog template
     */
    async deleteCatalogTemplateRaw(requestParameters: DeleteCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCatalogTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Deactivates/removes a catalog template. Access is restricted by configuration RLS.
     * Remove catalog template
     */
    async deleteCatalogTemplate(requestParameters: DeleteCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.deleteCatalogTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a single catalog template. Access is restricted by configuration RLS (tenant and scope).
     * Get catalog template by ID
     */
    async getCatalogTemplateRaw(requestParameters: GetCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getCatalogTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Returns a single catalog template. Access is restricted by configuration RLS (tenant and scope).
     * Get catalog template by ID
     */
    async getCatalogTemplate(requestParameters: GetCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.getCatalogTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns catalog templates visible to the current session. Includes system (global/Cobalt) templates and tenant-specific templates for the user\'s effective tenants. Optional scope filter: SYSTEM (global only) or TENANT (customer-specific only).
     * List catalog templates
     */
    async listCatalogTemplatesRaw(requestParameters: ListCatalogTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/catalog-templates`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationListResponseFromJSON(jsonValue));
    }

    /**
     * Returns catalog templates visible to the current session. Includes system (global/Cobalt) templates and tenant-specific templates for the user\'s effective tenants. Optional scope filter: SYSTEM (global only) or TENANT (customer-specific only).
     * List catalog templates
     */
    async listCatalogTemplates(requestParameters: ListCatalogTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationListResponse> {
        const response = await this.listCatalogTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing catalog template. Only name, description, and configurationData can be updated; scope and tenant are fixed.
     * Update catalog template
     */
    async updateCatalogTemplateRaw(requestParameters: UpdateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCatalogTemplate().'
            );
        }

        if (requestParameters['updateConfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateConfigurationRequest',
                'Required parameter "updateConfigurationRequest" was null or undefined when calling updateCatalogTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/catalog-templates/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateConfigurationRequestToJSON(requestParameters['updateConfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing catalog template. Only name, description, and configurationData can be updated; scope and tenant are fixed.
     * Update catalog template
     */
    async updateCatalogTemplate(requestParameters: UpdateCatalogTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponse> {
        const response = await this.updateCatalogTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
